import React from "react";
import {
    UseFormGetValues,
    UseFormRegister,
    UseFormSetValue,
    UseFormTrigger,
    UseFormClearErrors,
    UseFormWatch,
    FieldErrors,
} from "react-hook-form";

import { ItemInputs } from "./item.types";

export interface ItemFormContextType {
    register: UseFormRegister<ItemInputs>;
    watch: UseFormWatch<ItemInputs>;
    trigger: UseFormTrigger<ItemInputs>;
    clearErrors: UseFormClearErrors<ItemInputs>;
    setValue: UseFormSetValue<ItemInputs>;
    getValues: UseFormGetValues<ItemInputs>;
    errors: FieldErrors<ItemInputs>;
    shop?: any;
}

export const ItemFormContext = React.createContext<ItemFormContextType | null>(null);

export const useItemForm = () => {
    const context = React.useContext(ItemFormContext);
    if (!context) throw new Error('useItemForm must be used within ItemFormProvider');
    return context;
};

export type ItemFormInputs = ItemInputs;
